import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as Mail } from "../../assets/svg/mail-01.svg";
import { ReactComponent as Trash } from "../../assets/svg/trash-03.svg";
import { Table } from "../ui/Table";
import { useEffect, useMemo, useState } from "react";
import * as Yup from "yup";
import { inviteToTeam } from "../../services/api";
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { baseQueryAPI } from "../../services/baseQuery";

interface Team {
  first_name: string;
  last_name: string;
  email: string;
}

export const MyTeam = () => {
  const [team, setTeam] = useState<Team[]>([]);
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const emailValidator = Yup.string()
    .email("Enter valid email")
    .required("Email is required");

  const { data: myTeamData } = baseQueryAPI.useMyTeamQuery("");

  console.log("my team data: ", myTeamData);

  useEffect(() => {
    if (myTeamData) {
      setTeam(myTeamData.data);
    }
  }, [myTeamData]);

  const columnHelper = createColumnHelper<Team>();

  const columns = useMemo(
    () => [
      columnHelper.accessor("first_name", {
        cell: (info) => info.getValue(),
        header: "First Name",
      }),
      columnHelper.accessor("last_name", {
        cell: (info) => info.getValue(),
        header: "Last Name",
      }),
      columnHelper.accessor("email", {
        cell: (info) => info.getValue(),
        header: "Email",
      }),
      columnHelper.display({
        id: "action",
        cell(props) {
          return (
            <button>
              <Trash />
            </button>
          );
        },
      }),
    ],
    [columnHelper]
  );

  const table = useReactTable({
    columns,
    data: team,
    getCoreRowModel: getCoreRowModel(),
  });

  const invite = async () => {
    try {
      const value = await emailValidator.validate(email);
      setErrorMsg("");
      let result = await inviteToTeam({ email });
      if (!result?.data.success) {
        throw new Error(result?.data.message);
      }
      if (result.data.success) {
        setSuccessMsg("Invitation sent successfully!");
      }
    } catch (error) {
      console.error((error as any).message);
      setErrorMsg((error as any).message);
    }
  };

  return (
    <div className="w-full p-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900">Manage Team</h3>
        <button onClick={() => navigate("/")} className="h-10 w-10">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <div className="mt-6">
        <input
          type="text"
          name="email"
          id="invite"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="border px-4 py-3 w-full"
        />
        {errorMsg ? (
          <div className="mt-2 text-xs text-red-400">{errorMsg}</div>
        ) : null}
        {successMsg ? (
          <div className="mt-2 text-xs text-green-400">{successMsg}</div>
        ) : null}

        <div className="flex justify-between items-center mt-3">
          <button className="text-sm font-semibold text-gray-600 flex gap-x-1">
            {/* <span>
                            <FontAwesomeIcon icon={faPlus}/>
                        </span>
                        <span>Add another</span> */}
          </button>

          <button
            onClick={invite}
            className="bg-primary text-white px-4 py-3 text-s font-semibold flex gap-x-1"
          >
            <span>
              <Mail />
            </span>
            <span>Invite to my Team</span>
          </button>
        </div>

        <div className="mt-5">
          <Table heading={table.getHeaderGroups()} body={table.getRowModel()} />
        </div>
      </div>
    </div>
  );
};
